import React, {FC, ReactElement, useCallback, useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import {useService} from '@yosmanyga/di'
import {Button, Container, Icon, Input, Text, useIcons} from '@yosmanyga/rich-ui'
import {AuthenticationFrontendWithEmailStartController} from '../../controller'

const AuthenticationFrontendWithEmailStart = observer(({
    templates,
    email,
    onStarted
}: {
    templates: {
        layout: FC<{
            email_input: ReactElement,
            error: ReactElement | null,
            actions: ReactElement
        }>
    },
    email?: string,
    onStarted: (
        email: string
    ) => void
}) => {
    const icons = useIcons()

    const controller = useService(AuthenticationFrontendWithEmailStartController, [])

    useEffect(() => {
        controller.load(
            email
        )
    }, [])

    const handleSubmit = useCallback(async () => {
        await controller.start()

        if (controller.error) {
            return
        }

        onStarted(controller.email as string)
    }, [])

    if (controller.loading) {
        return <></>
    }

    return <templates.layout
        email_input={<Input
            value={controller.email}
            onChange={(value) => {
                controller.prepare(
                    value
                )
            }}
            placeholder='Type your email'
            width='100%'
        />}
        error={controller.error
            ? <Text
                intent="negative"
            >
                {controller.error}
            </Text>
            : null
        }
        actions={<Container
            flow="row wrap"
            align={{
                main: 'center'
            }}
        >
            <Button
                intent="primary"
                progress={controller.starting}
                disabled={controller.starting}
                onClick={handleSubmit}
            >
                <Icon
                    component={icons.actions.ok}
                    size='xxs'
                />
                <Text>Continue</Text>
            </Button>
        </Container>}
    />
})

export {
    AuthenticationFrontendWithEmailStart
}
